<template>
  <div class="modal" :class="{ 'modal--Sub': isChild }" @click.self="close">
    <button @click="closeModal()" class="modal__Overlay"></button>
    <success-prompt :updated="updated" :message="prompt.success"></success-prompt>

    <div class="modal__Inner" :class="{ 'modal__Inner--Sub': isChild }">
      <section class="modal__Post">
        <header class="modal__Header">
          <h1 class="modal__Title">{{ $route.name }}</h1>

          <div class="modal__Meta">
            <ul>
              <li class="modal__MetaItem--Button" v-if="$route.params.user_id !== undefined">
                <button @click="deleteUser()" :disabled="updated === true" class="button--Small button--Brand">
                  Delete user
                </button>
              </li>
              <li class="modal__MetaItem--Button">
                <button
                  @click="changeProp(item, 'Success! User has been updated')"
                  :disabled="updated === true"
                  class="button--Small"
                >
                  {{ prompt.save }}
                </button>
              </li>
              <li class="modal__MetaItem">
                <button @click="closeModal()" class="modal__MetaLink">
                  <icon name="times"></icon>
                </button>
              </li>
            </ul>
          </div>
        </header>

        <error-prompt class="error--Modal" :errors="errors"></error-prompt>
        <loader class="imageLoader" :loading="loading || updating" />

        <template>
          <div class="cardPreview">
            <div class="cardPreview__Columns">
              <div class="cardPreview__Column" v-if="item.status !== undefined">
                <h2 class="cardPreview__Title">{{ $store.getters.getStringTranslation('status') }}</h2>
                <p class="cardPreview__Status">{{ capitalize(item.status) }}</p>
              </div>
              <div class="cardPreview__Column" v-if="$route.params.user_id !== undefined">
                <h2 class="cardPreview__Title">{{ $store.getters.getStringTranslation('controls') }}</h2>
                <ul class="cardPreview__Meta">
                  <li v-if="item.status === 'pending'">
                    <button
                      class="cardPreview__MetaButton"
                      @click="changeProp({ status: 'active' }, 'Success! User has been activated.')"
                    >
                      <icon v-if="item.status === 'active'" name="eye-slash"></icon>
                      <icon v-else name="eye"></icon>Approve
                    </button>
                  </li>
                  <li v-if="item.is_org_admin">
                    <button
                      class="cardPreview__MetaButton"
                      @click="changeProp({ is_org_admin: false }, 'Success! User has been demoted.')"
                    >
                      <icon name="angle-double-down"></icon>Demote to user
                    </button>
                  </li>
                  <li v-else>
                    <button
                      class="cardPreview__MetaButton"
                      @click="changeProp({ is_org_admin: true }, 'Success! User has been promoted.')"
                    >
                      <icon name="angle-double-up"></icon>Promote to admin
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <form autocomplete="off" class="formSection">
            <div class="formSection__Row">
              <p>
                <label class="formLabel" for="editEmail">{{ $store.getters.getStringTranslation('email') }}</label>
                <input required v-model="item.email" type="email" class="formInput" id="editEmail" />
              </p>
              <p>
                <label class="formLabel" for="editPassword">{{
                  $store.getters.getStringTranslation('password')
                }}</label>
                <input required v-model="password" type="password" class="formInput" id="editPassword" />
                <span class="note">{{ $store.getters.getStringTranslation('leaveBlank') }}</span>
              </p>
            </div>

            <user-fields v-model="item" :user="item" :loading="loading && updating === false" />
          </form>
        </template>
      </section>
    </div>
  </div>
</template>

<script>
import HTTP from '@/http-common.js'

import GetTagByType from '@/components/mixins/GetTagByType.js'
import GetProperty from '@/components/mixins/GetProperty.js'
import Capitalize from '@/components/mixins/Capitalize.js'

import UserFields from '@/components/editor/UserFields.vue'
import Loader from '@/components/partials/Loader.vue'
import ErrorPrompt from '@/components/editor/ErrorPrompt.vue'
import SuccessPrompt from '@/components/editor/SuccessPrompt.vue'

export default {
  name: 'EditUser',
  components: {
    UserFields,
    Loader,
    ErrorPrompt,
    SuccessPrompt,
  },
  props: ['queryParams'],
  mixins: [GetTagByType, GetProperty, Capitalize],
  data() {
    return {
      item: {
        email: '',
        name: '',
        is_org_admin: false,
        l10n: [
          {
            position: '',
            description: '',
            lang: this.$store.state.ui.lang,
            contents: [],
          },
        ],
        contents: {
          thumbnail_urls: {},
          additionals: {
            phone: '',
            facebook: '',
            twitter: '',
            medium: '',
          },
        },
        tag_ids: [],
        tags: [],
        status: 'active',
      },
      password: '',
      country: [],
      prompt: {
        save: 'Save',
        success: '',
      },
      parent: null,
      loading: true,
      updating: false,
      updated: false,
      errors: '',
    }
  },
  computed: {
    tags() {
      return this.$store.state.tags.list
    },
    lang() {
      return this.$store.state.ui.lang
    },
    orgID() {
      if (this.$route.params.id) return this.$route.params.id
      return this.$store.state.accounts.org.id
    },
    isChild() {
      return this.$route.path.includes('organisations')
    },
  },
  created() {
    if (this.$route.params.user_id !== undefined) {
      HTTP.get(`org/${this.orgID}/member/${this.$route.params.user_id}`)
        .then((response) => {
          this.item = response.data
          this.loading = false

          if (this.item.l10n.length === 0)
            this.item.l10n = Object.assign([], this.item.l10n, [
              { position: '', description: '', lang: this.$store.state.ui.lang, contents: [] },
            ])
          if (this.item.contents.additionals === undefined)
            this.item.contents.additionals = Object.assign({}, this.item.contents.additionals, {
              phone: '',
              facebook: '',
              twitter: '',
              medium: '',
            })
          this.prompt.save = 'Save'
        })
        .catch((e) => {
          this.errors = e.response ? e.response.data : console.error(e)
          this.loading = false
        })
    } else {
      this.loading = false
      this.prompt.save = 'Create'
    }

    // Define parent URL
    let path = this.$route.matched[1].path
    if (this.isChild) path = this.$route.matched[1].path.replace(':id', this.$route.params.id)
    this.parent = {
      path,
      query: {
        search: JSON.stringify(this.queryParams),
      },
    }
  },
  watch: {
    password() {
      if (this.password.length > 0) {
        this.item.password = this.password
      } else {
        delete this.item.password
      }
    },
  },
  methods: {
    closeModal() {
      if (this.changed === true) {
        if (confirm('Are you sure you wish to close the editor? Everything not saved will be lost!')) {
          this.$router.push(this.parent)
        }
      } else {
        this.$router.push(this.parent)
      }
    },
    changeProp(obj, message) {
      this.loading = true
      this.updating = true

      let url = `org/${this.orgID}/member/`
      if (this.$route.params.user_id !== undefined) url = `org/${this.orgID}/member/update/${this.item.id}`

      HTTP.post(url, obj)
        .then((response) => {
          this.item = response.data
          this.loading = false
          this.updating = false
          this.updated = true
          this.prompt.success = message
          this.errors = []

          if (this.$route.params.user_id !== undefined) {
            this.$store.dispatch('updateSingleUser', {
              item: response.data,
              status: this.item.status,
            })
          } else {
            this.prompt.success = 'Success! User has been created.'
            this.$store.dispatch('addNewUser', response.data)
          }

          // Enable edit
          setTimeout(() => {
            this.updated = false
          }, 3000)
        })
        .catch((e) => {
          console.log(e)
          this.errors = e.response ? e.response.data : console.error(e)
          this.loading = false
          this.updating = false
        })
    },
    deleteUser() {
      if (
        confirm(
          `Are you sure you wish to delete ${this.item.name}? All user contributed resources will remain but no user will be assigned to them.`
        )
      ) {
        this.loading = true

        HTTP.delete(`org/${this.orgID}/member/${this.item.id}`).then(() => {
          this.$store.dispatch('deleteUser', { id: this.item.id, status: this.item.status })
          this.updated = true
          this.loading = false
          this.prompt.success = 'Success! User has been removed.'

          // Enable edit
          setTimeout(() => {
            this.$router.push(this.parent)
          }, 3000)
        })
      }
    },
  },
}
</script>
